export const environment = {
  production: true,
  apiUrl: 'https://reporting-old.rao.hr',
  version: '1.0.2',
  sentry: {
    dsn: 'https://bb0d26d3ba370f931d8ca316b89e2eea@o4510284195758080.ingest.de.sentry.io/4510549456322640',
    environment: 'production',
    tracesSampleRate: 0.1,
    sendDefaultPii: true
  }
};
